module.exports = __webpack_public_path__ + "media/images/screens/01_homepage-6ea85fc289d0155079e931954ab57d81.jpg";